/*
* Lomtec jQuery functions / extensions scripts
*
* Copyright (c) 2012 Lomtec.com
* http://www.lomtec.com
*
* Author : martin baluska
* Released: March 2015
*/

(function ($) {

    /* jQuery function extension */

    $.fn.extend({
		
		activeScroll: function (obj) {
			
			var element = $(this);
			
			$('a[data-anchor]').removeClass("active");
		    $('a[data-anchorid='+ obj +']').addClass(" active");
		},
	
		animateScroll: function(elem) {

			var element = $(this);

			if(element.length > 0) {
				var topOffset = element.offset().top - 60;
				$('html, body').animate({ scrollTop: topOffset}, 800);
			}		
		}	

	});	

})(jQuery);
